<template>
  <div>
    <GoodsTable :tcOrderCode="tcOrderCode" :disabled="disabled" />
  </div>
</template>
<script>
import GoodsTable from './components/table'
export default {
  components: { GoodsTable },
  props: {
    tcOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>
